import { type ChatStatus, type ChatType } from "@fitness-app/data-models/entities/Chat";

import { type StoreDependencies } from "../../../index";

type Db = StoreDependencies["db"];

export type ChatChannelsListQueryParams = {
  status: ChatStatus;
  searchValue?: string;
  type?: ChatType[];
  /** Auth user id of the coach whose chats should be listed (still scoped to viewer membership). */
  trainerUserId?: string;
};

const channelListSelectWithProfileInner =
  "*, lastMessage:lastMessageId(id, content, createdAt, files), profiles:user_profile!inner(avatarUrl, firstName, lastName, id, email))";

/** Baseline ordered query shared by fetchInitialChatListPage and getNextChatListPage */
export function buildOrderedChatChannelsListQuery(db: Db, currentUserId: string, params: ChatChannelsListQueryParams) {
  const assignedIds =
    params.trainerUserId && params.trainerUserId !== currentUserId ? [params.trainerUserId] : [currentUserId];

  let query = db
    .from("chat_channel")
    .select(channelListSelectWithProfileInner)
    .order("updatedAt", { ascending: false })
    .contains("assignedUsers", assignedIds)
    .eq("status", params.status);

  if (params.searchValue) {
    const v = params.searchValue;
    query = query.or(`lastName.ilike.%${v}%,email.ilike.%${v}%,firstName.ilike.%${v}%`, {
      referencedTable: "user_profile",
    });
  }

  if (params.type?.length) {
    query = query.in("type", params.type);
  }

  return query;
}
